import React from "react";
import { Button } from "../ui/button";
import { Brain, Home, TrendingUp, Wrench } from "lucide-react";

const WhyChooseSection = () => {
  const reasons = [
    {
      icon: Brain,
      title: "Smart Growth",
      description: "We integrate advanced tools that handle calls, follow-ups, and marketing—saving you hours every week."
    },
    {
      icon: Home,
      title: "Real Estate Expertise",
      description: "We know your market, your audience, and exactly what works to get more listings and close more deals."
    },
    {
      icon: TrendingUp,
      title: "Proven Results",
      description: "Clients see up to a 30% boost in lead conversion and spend less time chasing cold leads."
    },
    {
      icon: Wrench,
      title: "Done-For-You Service",
      description: "From funnels to ads to CRM—everything is set up, managed, and optimized for you."
    }
  ];

  const handleBookCall = () => {
    alert("Booking call functionality - this would redirect to calendar booking");
  };

  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Why Real Estate Pros Choose{" "}
            <span className="text-transparent bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text">
              Golden Cortex
            </span>
          </h2>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {reasons.map((reason, index) => {
            const IconComponent = reason.icon;
            return (
              <div
                key={index}
                className="text-center bg-gray-900/50 backdrop-blur-sm border border-gray-700 rounded-lg p-6 hover:border-yellow-400 transition-all duration-300 transform hover:scale-105 group"
              >
                {/* Icon */}
                <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="w-8 h-8 text-black" />
                </div>
                
                {/* Title */}
                <h3 className="text-lg font-semibold text-white mb-3 group-hover:text-yellow-400 transition-colors">
                  {reason.title}
                </h3>
                
                {/* Description */}
                <p className="text-gray-400 text-sm leading-relaxed">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <Button
            onClick={handleBookCall}
            className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-8 py-3 text-lg transition-all duration-300 transform hover:scale-105"
          >
            Book A Call
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;